import { ProviderIcon } from '@tackle-io/platform-ui';
import { Box, makeStyles } from 'vendor/material';
import {
  CurrentComponent,
  ProspectComponentIdentifier,
} from './ProspectComponentSelector';
import { ScoreTag } from './ScoreTag';

interface AwsEngagementInfoProps {
  score: string | undefined;
  navigateBack: (currentComponent: CurrentComponent) => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    height: '100%',
    overflow: 'hidden',
  },
  header: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '20px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  aboutTheScoreHeader: {
    borderBottom: '1px solid #EBECF0',
    fontSize: '12px',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    paddingBottom: '8px',
  },
  backText: {
    color: '#0052CC',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '20px',
    letterSpacing: '0%',
    cursor: 'pointer',
  },
  paragraph: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '20px',
    letterSpacing: '0%',
  },
}));

const AwsEngagementInfo: React.FC<AwsEngagementInfoProps> = (
  props: AwsEngagementInfoProps,
) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.container}
      display="flex"
      flexDirection="column"
      gridGap={12}
    >
      <Box display="flex" flexDirection="column" gridGap={8}>
        <Box
          onClick={() =>
            props.navigateBack({
              componentId: ProspectComponentIdentifier.DETAIL_AND_SCORING,
            })
          }
        >
          <span className={classes.backText}>&lt; Back</span>
        </Box>
        <Box display="flex" gridGap={4}>
          <ProviderIcon fontSize={'small'} provider="aws" />
          <span className={classes.header}>Marketplace engagement</span>
        </Box>
      </Box>
      <Box gridGap={8} display="flex" flexDirection="column">
        <Box
          className={classes.aboutTheScoreHeader}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <span>About the score</span>
          <ScoreTag score={props.score} />
        </Box>
        <Box>
          <span className={classes.paragraph}>
            This score is provided by AWS. It is a prioritization value that
            displays an estimate (High, Medium, or Low) of how likely the
            customer in an opportunity is to procure a solution through AWS
            Marketplace.
          </span>
        </Box>
        <Box>
          <span className={classes.paragraph}>
            For opportunities that do not have an AWS Marketplace engagement
            score displayed, either AWS was unable to assign a score based on
            currently available information and inputs, or you haven't started
            to co-sell on any opportunities for the account. AWS provides
            engagement scores for all accepted co-sell opportunities.
          </span>
        </Box>
      </Box>
    </Box>
  );
};

export default AwsEngagementInfo;
